import axios from 'axios';

const evaluationPageApi = axios.create({
  baseURL: `/course-evaluations/student/evaluation`,
});

export const getEvaluationPage = async (brandId, hashedStudentId, language) => {
  const params = { bId: brandId, uId: hashedStudentId, language };
  let { data } = await evaluationPageApi.get('/page', { params });
  return data;
};

export const getEvaluationTasks = async (
  brandId,
  hashedStudentId,
  language
) => {
  const params = { bId: brandId, uId: hashedStudentId, language };
  if (language) {
    params.language = language;
  }
  let { data } = await evaluationPageApi.get('/tasks', { params });
  return data;
};

export const isRetakeLinksEnabled = async (brandId) => {
  const params = { brandId: brandId };
  let { data } = await evaluationPageApi.get('/is-retake-links-enabled', { params });
  return data;
}

export const isCustomTextEnabledService = async (brandId) => {
  const params = { brandId: brandId };
  let { data } = await evaluationPageApi.get('/is-custom-text-enabled', { params });
  return data;
}

export const getSurveyLinkUrl = async (transactionId, distributionId, brandId, language, channel, hashedStudentId) => {
  const params = {
    transactionId: transactionId,
    distributionId: distributionId,
    brandId: brandId,
    language: language,
    channel: channel,
    uId: hashedStudentId
  };

  let { data } = await evaluationPageApi.get('/survey-link', { params });
  return data;
}